import { FormControlProps } from 'components/common/form/layout/control';
import {
    BlockType,
    ComponentSettings,
    DatasetField,
    BlockFactoryManageFilters,
    ComponentSettingsManageFilters,
    RendererFilter,
} from '@report-content';
import { YNValues } from 'tools/types';

export interface FormControlReportContentEditorProps extends FormControlProps {
    isPermittedToEditDataset: boolean;
}

export interface ReportContentActions {
    openBlockEditor: (blockUID: string, editPanel: any, options?: any) => void;
    removeBlock: (blockUID: string, withConfirm?: boolean) => void;
    sortBlocks: (sourceIndex: number, destinationIndex: number) => void;
    updateMeasurementTime: (measurementTime: string) => void;
    updateSegmentValue: (newSegmentValueId: string) => void;
    updateBlockSettings: (
        blockUID: string,
        newSettings: ComponentSettings,
        options?: { shouldDirty?: boolean },
    ) => void;
    setBlockPreviewInd: (blockUID?: string) => void;
    getBlocks: () => Array<BlockType<any>>;
}

export function buildManageFiltersBlock(
    rendererFilters: ComponentSettingsManageFilters,
    datasetFields: Array<DatasetField>,
): BlockType<ComponentSettingsManageFilters> {
    const block = new BlockFactoryManageFilters().getNewBlock({
        nextUId: -1,
        nextSortOrder: -1,
        datasetFields: datasetFields,
    });

    if (
        (typeof rendererFilters.fields == 'undefined' || rendererFilters.fields.length == 0) &&
        datasetFields.length > 0
    ) {
        block.component.settings = {
            ...rendererFilters,
            fields: datasetFields.map((f) => ({
                ...f,
                filterType: 'dropdown',
                filter_column: 'N',
                sortDirection: 'ASC',
                numeric_type: f.value_type == 'numeric' ? 'float' : null,
            })),
        };
    } else {
        block.component.settings = rendererFilters;
    }
    return block;
}

export function prepareDatasetFieldEscapedName(newList: Array<DatasetField>) {
    // Prepare reference name in legacy format
    return newList.map((field) => ({
        ...field,
        reference_name_escaped: field.reference_name
            .replace(/"/g, '_1')
            .replace(/</g, '_2')
            .replace(/>/g, '_3')
            .replace(/\s/g, '_4'),
    }));
}

export interface IReportDownloadFilterRule {
    field: string;
    skip_trim_value?: YNValues;
    condition: string;
    data?: any;
}
export function formatMenageFiltersBlockForDownload(fields: Array<RendererFilter>) {
    const rules: IReportDownloadFilterRule[] = [];
    fields
        .filter((field) => field.filter_column == 'Y')
        .forEach((field) => {
            if ('multiselect' === field.filterType) {
                if (field.savedValues?.length) {
                    rules.push({
                        field: field.reference_name,
                        skip_trim_value: 'Y',
                        condition: 'is in list',
                        data: field.savedValues,
                    });
                }
            } else if ('range' === field.filterType && (field.savedValues?.length ?? 0) > 1) {
                let val = field!.savedValues?.[0];
                if ('' !== val && null !== val && 'undefined' !== typeof val) {
                    rules.push({
                        field: field.reference_name,
                        condition: '>=',
                        data: val,
                    });
                }

                val = field!.savedValues?.[1];
                if ('' !== val && null !== val && 'undefined' !== typeof val) {
                    rules.push({
                        field: field.reference_name,
                        condition: '<=',
                        data: val,
                    });
                }
            } else if ('charting_interval' === field.filterType) {
                let val = field.savedValues?.[0];
                if ('' !== val && null !== val && 'undefined' !== typeof val) {
                    rules.push({
                        field: field.reference_name,
                        condition: '>=',
                        data: val,
                    });
                }
            } else {
                let val = field.savedValues;
                if (Array.isArray(val)) {
                    val = val[0];
                }
                //@ts-ignore
                if ('undefined' !== typeof val && ' ' !== val && '' !== val && null !== val) {
                    if ('Y' === field?.use_external_filter_value && 'string' === typeof field?.external_delimiter) {
                        let t: string = Array.isArray(val) ? val[0] : val;

                        rules.push({
                            field: field.reference_name,
                            condition: 'is in list',
                            data: t.split(field.external_delimiter),
                        });
                    } else {
                        rules.push({
                            field: field.reference_name,
                            condition: '=',
                            data: val,
                        });
                    }
                }

                // else if (
                //     $('.ds_filters_select[uid="' + field.reference_name_escaped + '"] > option:selected').length &&
                //     'Y' ===
                //         $('.ds_filters_select[uid="' + field.reference_name_escaped + '"] > option:selected').data(
                //             'is_empty',
                //         )
                // )
                //     rules.push({ field: field.reference_name, condition: 'is empty' });
            }
        });
    return rules.length > 0 ? JSON.stringify({ operator: 'AND', rules: rules }) : undefined;
}
